const TaskStatusTypes = {
    // get report
    GET_ALL_TASK_STATUS: "GET_ALL_TASK_STATUS",
    GET_ALL_TASK_STATUS_LOADING: "GET_ALL_TASK_STATUS_LOADING",
    GET_ALL_TASK_STATUS_SUCCESS: "GET_ALL_TASK_STATUS_SUCCESS",
    GET_ALL_TASK_STATUS_RESET: "GET_ALL_TASK_STATUS_RESET",
    GET_ALL_TASK_STATUS_ERROR: "GET_ALL_TASK_STATUS_ERROR",

    CREATE_TASK_STATUS: "CREATE_TASK_STATUS",
    CREATE_TASK_STATUS_LOADING: "CREATE_TASK_STATUS_LOADING",
    CREATE_TASK_STATUS_SUCCESS: "CREATE_TASK_STATUS_SUCCESS",
    CREATE_TASK_STATUS_RESET: "CREATE_TASK_STATUS_RESET",
    CREATE_TASK_STATUS_ERROR: "CREATE_TASK_STATUS_ERROR",

    EDIT_TASK_STATUS: "EDIT_TASK_STATUS",
    EDIT_TASK_STATUS_LOADING: "EDIT_TASK_STATUS_LOADING",
    EDIT_TASK_STATUS_SUCCESS: "EDIT_TASK_STATUS_SUCCESS",
    EDIT_TASK_STATUS_RESET: "EDIT_TASK_STATUS_RESET",
    EDIT_TASK_STATUS_ERROR: "EDIT_TASK_STATUS_ERROR",
}
export default TaskStatusTypes;